<template>
    <CieloLayout>
        <router-view v-if="!loading" />

        <div class="row" v-if="loading">
            <MoonLoader color="#00AEEF" size="70px" class="loader mx-auto mt-5 mb-4" />
        </div>
    </CieloLayout>
</template>

<script>
    import { mapGetters } from 'vuex';

    import loader from '@/helpers/loader';
    import MoonLoader from 'vue-spinner/src/MoonLoader';
    import CieloLayout from '@/components/layout/CieloLayout';

    export default {
        components: {
            MoonLoader,
            CieloLayout,
        },

        async created() {
            loader.multiLanguage = this.$ml;
            if(!this.selectedCard || Object.keys(this.selectedCard).length === 0) this.$store.dispatch('pipelineV2/pushTo', 'ChangePaymentType');
        },

        watch: {
            selectedCard(newVal) {
                if (!newVal || Object.keys(newVal).length === 0) this.$store.dispatch('pipelineV2/pushTo', 'ChangePaymentType');
            }
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            ...mapGetters({
                selectedCard: 'dataOnFile/getSelectedCard',
            }),
        },
    };
</script>

<style lang="scss" scoped>
    .loader {
        display: block;
        width: 70px;
        height: 70px;
    }
</style>
